import { AccessDenied, Admin, CustomRoutes, Resource } from "react-admin";
import { authProvider, dataProvider, i18nProvider } from "@/providers";
import {
  bogo,
  cashier,
  Dashboard,
  discount,
  entities,
  entitieslocation,
  giftcards,
  locations,
  LoginPage,
  productsoffered,
  users,
  vouchers,
} from "./pages";
import { lightTheme } from "./theme";
import { queryClient } from "./utilities";
import { QueryClientProvider } from "react-query";
import { CustomLayout } from "./components";
import { Fragment } from "react";
import type { JSX } from "react";
import { Route } from "react-router-dom";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { Home } from "./pages/dashboard";

const resourcesByRole: Record<string, JSX.Element[]> = {
  admin: [
    <Resource key="users" name="users" {...users} />,
    <Resource key="entities" name="entities" {...entities} />,
    <Resource key="locations" name="locations" {...locations} />,
    <Resource key="vouchers" name="vouchers" {...vouchers} />,
  ],

  entity: [
    <Resource key="discount" name="discount" {...discount} />,
    <Resource key="giftcards" name="giftcards" {...giftcards} />,
    <Resource key="bogo" name="bogo" {...bogo} />,
    <Resource
      key="productsoffered"
      name="productsoffered"
      {...productsoffered}
    />,
    <Resource
      key="entitieslocation"
      name="entitieslocation"
      {...entitieslocation}
    />,
    <Resource key="locations" name="locations" {...locations} />,
    <Resource key="vouchers" name="vouchers" {...vouchers} />,
    <Resource key="cashier" name="cashier" {...cashier} />,
  ],

  cashier: [<Resource key="vouchers" name="vouchers" {...vouchers} />],
};

const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <Admin
          dataProvider={dataProvider}
          authProvider={authProvider}
          theme={lightTheme}
          layout={CustomLayout}
          accessDenied={AccessDenied}
          loginPage={LoginPage}
          requireAuth
          disableTelemetry
          i18nProvider={i18nProvider}
          dashboard={Home}
        >
          {(permissions) => {
            const role = String(permissions || "").toLowerCase();

            return (
              <Fragment>
                {resourcesByRole[role] ?? []}
                <CustomRoutes>
                  <Route path="/dashboard" element={<Dashboard />} />
                </CustomRoutes>
              </Fragment>
            );
          }}
        </Admin>
      </LocalizationProvider>
    </QueryClientProvider>
  );
};

export default App;
